/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';
import LogLevels from 'CoreConstants/LogLevels';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_LOCAL,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.LOCAL,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.LOCAL,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.LOCAL,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.LOCAL,
  logging: {
    console: LogLevels.debug,
    elastic: LogLevels.debug
  },
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.DEV_APP_ID,
      appCode: HereMapsCredentials.DEV_APP_CODE,
      useCIT: true
    }
  }
};

export default config;
